// "Research about {country}" in the country panel: the newest research papers
// tagged with that country, linking to the Research page (/research).
// Hidden when there are none (most papers are global, not about one country).

import { t, lang, countryName } from '../i18n/index.js';

const cache = new Map();
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

function load(iso2) {
    if (!cache.has(iso2)) {
        cache.set(
            iso2,
            fetch(`/api/research?country=${encodeURIComponent(iso2)}&limit=4`)
                .then((r) => (r.ok ? r.json() : { data: [], total: 0 }))
                .catch(() => ({ data: [], total: 0 })),
        );
    }
    return cache.get(iso2);
}

export async function renderCountryResearch(iso2, fallbackName = '') {
    const box = document.getElementById('panel-research');
    if (!box) return;
    box.dataset.iso2 = iso2;
    box.hidden = true;
    const { data = [], total = 0 } = await load(iso2);
    if (box.dataset.iso2 !== iso2 || !data.length) return; // another country opened meanwhile, or nothing to show

    const date = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' });
    const q = `country=${encodeURIComponent(iso2)}`;
    box.querySelector('.panel-section-title').textContent = t('panel.research', { country: countryName(iso2, fallbackName) });
    box.querySelector('.pr-list').innerHTML = data
        .map(
            (p) => `<li class="pr-item"><a href="/research?${q}&paper=${p.id}">
  <span class="pr-topic"><span class="rs-dot rs-t-${esc(p.topic)}"></span>${esc(t(`rt.${p.topic}`))}</span>
  <span class="pr-title">${esc(p.title)}</span>
  <span class="pr-meta">${esc(p.source_name)} · ${esc(date.format(new Date(p.published_at)))}</span></a></li>`,
        )
        .join('');
    const all = box.querySelector('.pr-all');
    all.href = `/research?${q}`;
    all.textContent = `${t('panel.researchAll')}${total > data.length ? ` (${total})` : ''}`;
    box.hidden = false;
}
